let exit_popup = require('./exit-popup.js');
exit_popup.init();


// WEBPACK FOOTER //
// ./assets/src/js/index.js